import * as React from "react";
import { forwardRef } from "react";
const SvgIconGoogleTick = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5.08684 9.48297L2.59764 7.12484L1.75 7.9222L5.08684 11.0833L12.25 4.29735L11.4083 3.5L5.08684 9.48297Z", fill: "#33D27E" }));
const ForwardRef = forwardRef(SvgIconGoogleTick);
export default ForwardRef;
